import { LoaderStyle } from './styled'

const Loader = (props: any) => {
  const { intro = false, skipVid } = props
  return (
    <LoaderStyle>
      <span className="loader"></span>
      {intro ? (
        <>
          <div className="loaderText">
            Loading intro video<span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
            <div className="mt-2">
              If it takes too long and you do not wish to wait
            </div>
          </div>
          <a
            href="#"
            className="text-danger"
            onClick={skipVid}
            style={{ fontSize: '.8em' }}
          >
            Click here to skip
          </a>
        </>
      ) : (
        <div className="loaderText">
          Please wait<span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </div>
      )}
    </LoaderStyle>
  )
}

export default Loader
